export default {
  BOTTOM: 'bottom',
  TOP: 'top',
  LEFT: 'left',
  RIGTH: 'right'
};
